(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6],{

/***/ 1173:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reset-password",
      function () {
        return __webpack_require__(8582);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ FooterNav; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8527);



var FooterNav = function(param) {
    var colorScheme = param.colorScheme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
        gap: 3,
        justifyContent: "center",
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                    variant: "nav",
                    color: colorScheme,
                    children: "\xa9 Joyline"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                w: "2px",
                height: "16px",
                bgColor: colorScheme,
                opacity: ".2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/support",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                    variant: "nav",
                    color: colorScheme,
                    children: "Support"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                w: "2px",
                height: "16px",
                bgColor: colorScheme,
                opacity: ".2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/privacy",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                    variant: "nav",
                    color: colorScheme,
                    children: "Privacy"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
                w: "2px",
                height: "16px",
                bgColor: colorScheme,
                opacity: ".2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/terms",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Link */ .rU, {
                    variant: "nav",
                    color: colorScheme,
                    children: "Terms"
                })
            })
        ]
    });
};


/***/ }),

/***/ 7510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Logo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);


var Logo = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: "/images/logo.svg",
        width: 140,
        height: 36,
        alt: "Joyline"
    });
};


/***/ }),

/***/ 6299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ PageLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8527);


var PageLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
            w: "full",
            minHeight: "100vh",
            bgGradient: "linear(to-br, #E9FEF4, #FEFCEA, #F8F0F0)",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: children
            })
        })
    });
};


/***/ }),

/***/ 5444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ SectionCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8527);


var SectionCard = function(param) {
    var title = param.title, titleCentered = param.titleCentered, iconSlot = param.iconSlot, descriptionSlot = param.descriptionSlot, actionSlot = param.actionSlot, footerSlot = param.footerSlot, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Stack */ .Kq, {
        as: "section",
        p: {
            base: 4,
            lg: 8
        },
        spacing: 8,
        bgColor: "white",
        borderRadius: "xl",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Stack */ .Kq, {
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                            as: "header",
                            justifyContent: titleCentered ? "center" : "space-between",
                            alignItems: "center",
                            gap: 4,
                            flexDir: {
                                base: "column",
                                sm: "row"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                                    alignItems: "center",
                                    gap: 4,
                                    children: [
                                        iconSlot,
                                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6, {
                                            as: "h1",
                                            size: "h1",
                                            children: title
                                        })
                                    ]
                                }),
                                actionSlot
                            ]
                        }),
                        descriptionSlot && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                            children: descriptionSlot
                        })
                    ]
                })
            }),
            children,
            footerSlot && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                as: "footer",
                children: footerSlot
            })
        ]
    });
};


/***/ }),

/***/ 1568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ SectionGroup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8527);


var SectionGroup = function(param) {
    var title = param.title, actionSlot = param.actionSlot, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
        borderRadius: "lg",
        border: "2px",
        borderColor: "light-blue",
        p: {
            base: 4,
            lg: 8
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Stack */ .Kq, {
            spacing: 8,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6, {
                        as: "h2",
                        size: "h3",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                        children: children
                    }),
                    actionSlot && actionSlot
                ]
            })
        })
    });
};


/***/ }),

/***/ 9425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Seo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);


var description = "Subscribe today and send some joy to your loved ones every month. Joyline will print and send your favorite pictures to the people in your life who prefer print over a screen.";
var Seo = function(param) {
    var _title = param.title, title = _title === void 0 ? "Joyline | Send printed photos" : _title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        title: title,
        description: description,
        canonical: "https://www.joyline.io/",
        openGraph: {
            url: "https://www.joyline.io/",
            title: "Send printed photos to loved ones monthly with Joyline.io",
            description: description,
            images: [
                {
                    url: "https://www.joyline.io/images/og/1200x630.png",
                    width: 1200,
                    height: 630,
                    alt: "Happy seniors, thanks to Joyline",
                    type: "image/jpeg"
                },
                {
                    url: "https://www.joyline.io/images/og/1200x600.png",
                    width: 1200,
                    height: 600,
                    alt: "Happy seniors, thanks to Joyline",
                    type: "image/jpeg"
                }, 
            ],
            site_name: "Joyline.io"
        },
        twitter: {
            handle: "@joyline_io",
            site: "@joyline_io",
            cardType: "summary_large_image"
        }
    });
};


/***/ }),

/***/ 8582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ reset_password; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(8527);
// EXTERNAL MODULE: ./src/components/footer-nav.tsx
var footer_nav = __webpack_require__(8445);
// EXTERNAL MODULE: ./src/components/page-layout.tsx
var page_layout = __webpack_require__(6299);
// EXTERNAL MODULE: ./src/components/seo.tsx
var seo = __webpack_require__(9425);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/toast/dist/chakra-ui-toast.esm.js
var chakra_ui_toast_esm = __webpack_require__(6933);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/chakra-ui-form-control.esm.js
var chakra_ui_form_control_esm = __webpack_require__(9762);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/chakra-ui-input.esm.js
var chakra_ui_input_esm = __webpack_require__(4612);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js
var chakra_ui_button_esm = __webpack_require__(5193);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/zod/dist/zod.module.js + 1 modules
var zod_module = __webpack_require__(6522);
// EXTERNAL MODULE: ./src/components/logo.tsx
var logo = __webpack_require__(7510);
// EXTERNAL MODULE: ./src/components/section-card.tsx
var section_card = __webpack_require__(5444);
// EXTERNAL MODULE: ./src/components/section-group.tsx
var section_group = __webpack_require__(1568);
// EXTERNAL MODULE: ./src/libs/supabase.ts + 46 modules
var supabase = __webpack_require__(2257);
;// CONCATENATED MODULE: ./src/features/reset-password/index.tsx













var resetPasswordSchema = lib/* object */.Ry({
    email: lib/* string */.Z_().email()
});
var ResetPasswordForm = function() {
    var ref;
    var toast = (0,chakra_ui_toast_esm/* useToast */.pm)();
    var ref1 = (0,index_esm/* useForm */.cI)({
        resolver: (0,zod_module/* zodResolver */.F)(resetPasswordSchema),
        shouldUseNativeValidation: false,
        reValidateMode: "onChange",
        mode: "onChange",
        defaultValues: {
            email: ""
        }
    }), register = ref1.register, handleSubmit = ref1.handleSubmit, _formState = ref1.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, isValid = _formState.isValid;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
            var error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return supabase/* supabase.auth.api.resetPasswordForEmail */.O.auth.api.resetPasswordForEmail(values.email);
                    case 2:
                        error = _ctx.sent.error;
                        if (error) {
                            toast({
                                title: "An error occurred",
                                description: error.message ? error.message : "An error occurred, please try again",
                                status: "error",
                                isClosable: true
                            });
                            console.error(error);
                        } else {
                            toast({
                                title: "Password reset started",
                                description: "Check your email for the next step",
                                status: "info",
                                isClosable: true
                            });
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(section_card/* SectionCard */.q, {
            title: "Reset password",
            footerSlot: /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionFooter, {
                isValid: isValid,
                isSubmitting: isSubmitting
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Stack */.Kq, {
                spacing: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(section_group/* SectionGroup */.P, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Stack */.Kq, {
                        spacing: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                            isInvalid: Boolean(errors.email),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormLabel */.lX, {
                                    htmlFor: "email",
                                    children: "Email address"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                    maxW: "sm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_input_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                                        id: "email",
                                        type: "email"
                                    }, register("email", {
                                        required: "Email is required"
                                    })))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormErrorMessage */.J1, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: (ref = errors.email) === null || ref === void 0 ? void 0 : ref.message
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
var SectionFooter = function(param) {
    var isValid = param.isValid, isSubmitting = param.isSubmitting;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
        justifyContent: "space-between",
        gap: 4,
        flexDir: {
            base: "column-reverse",
            lg: "row"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* Logo */.T, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                alignItems: "center",
                gap: 4,
                flexDir: {
                    base: "column-reverse",
                    lg: "row"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        fontSize: "xs",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/log-in",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                    as: "span",
                                    fontSize: "xs",
                                    fontWeight: "bold",
                                    textDecor: "underline",
                                    children: "Go back to log in"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                        isLoading: isSubmitting,
                        disabled: !isValid || isSubmitting,
                        type: "submit",
                        children: "Reset password"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/reset-password/new-password-form.tsx














var newPasswordSchema = lib/* object */.Ry({
    password: lib/* string */.Z_()
});
var NewPasswordForm = function(param) {
    var accessToken = param.accessToken;
    var ref;
    var router = (0,next_router.useRouter)();
    var toast = (0,chakra_ui_toast_esm/* useToast */.pm)();
    var ref1 = (0,index_esm/* useForm */.cI)({
        resolver: (0,zod_module/* zodResolver */.F)(newPasswordSchema),
        shouldUseNativeValidation: false,
        reValidateMode: "onChange",
        mode: "onChange",
        defaultValues: {
            password: ""
        }
    }), register = ref1.register, handleSubmit = ref1.handleSubmit, _formState = ref1.formState, errors = _formState.errors, isSubmitting = _formState.isSubmitting, isValid = _formState.isValid;
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
            var error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return supabase/* supabase.auth.api.updateUser */.O.auth.api.updateUser(accessToken, {
                            password: values.password
                        });
                    case 2:
                        error = _ctx.sent.error;
                        if (error) {
                            toast({
                                title: "An error occurred",
                                description: error.message ? error.message : "An error occurred, please try again",
                                status: "error",
                                isClosable: true
                            });
                            console.error(error);
                        } else {
                            toast({
                                title: "Success",
                                description: "You remembered your password!",
                                status: "success",
                                isClosable: true
                            });
                            router.push("/log-in");
                        }
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(section_card/* SectionCard */.q, {
            title: "Enter new password",
            footerSlot: /*#__PURE__*/ (0,jsx_runtime.jsx)(new_password_form_SectionFooter, {
                isValid: isValid,
                isSubmitting: isSubmitting
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Stack */.Kq, {
                spacing: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(section_group/* SectionGroup */.P, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Stack */.Kq, {
                        spacing: 4,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_form_control_esm/* FormControl */.NI, {
                            isInvalid: Boolean(errors.password),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormLabel */.lX, {
                                    htmlFor: "password",
                                    children: "Enter new password"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                    maxW: "sm",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_input_esm/* Input */.II, (0,_object_spread/* default */.Z)({
                                        id: "password",
                                        type: "password"
                                    }, register("password", {
                                        required: "Password is required"
                                    })))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_form_control_esm/* FormErrorMessage */.J1, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: (ref = errors.password) === null || ref === void 0 ? void 0 : ref.message
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
var new_password_form_SectionFooter = function(param) {
    var isValid = param.isValid, isSubmitting = param.isSubmitting;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
        justifyContent: "space-between",
        gap: 4,
        flexDir: {
            base: "column",
            lg: "row"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* Logo */.T, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                alignItems: "center",
                gap: 4,
                flexDir: {
                    base: "column-reverse",
                    lg: "row"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        fontSize: "xs",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/sign-up",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                    as: "span",
                                    fontSize: "xs",
                                    fontWeight: "bold",
                                    textDecor: "underline",
                                    children: "Go back to log in"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                        isLoading: isSubmitting,
                        disabled: !isValid || isSubmitting,
                        type: "submit",
                        children: "Reset password"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/reset-password.tsx








var ResetPassword = function() {
    var router = (0,next_router.useRouter)();
    var accessToken = router.query.accessToken;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(page_layout/* PageLayout */.X, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* Seo */.p, {
                title: "Reset password for Joyline.io"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Container */.W2, {
                maxW: "4xl",
                py: {
                    base: 4,
                    lg: 16
                },
                children: [
                    accessToken ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NewPasswordForm, {
                        accessToken: accessToken
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ResetPasswordForm, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                        h: 8
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_nav/* FooterNav */.H, {
                        colorScheme: "medium-gray"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var reset_password = (ResetPassword);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [962,527,61,998,774,888,179], function() { return __webpack_exec__(1173); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);